<template>
  <div class="exam-vault-views">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane
        v-if="userAccessLevel === 'Teacher'"
        :label="$t('TEACHER')"
        name="Teacher"
      >
        <ExamVault
          :selectable="true"
          @selectExam="handleSelectExam"
          access-level="Teacher"
        />
      </el-tab-pane>
      <el-tab-pane
        v-if="userAccessLevel !== 'Group'"
        :label="$t('SCHOOL')"
        name="School"
      >
        <ExamVault
          :selectable="true"
          @selectExam="handleSelectExam"
          access-level="School"
        />
      </el-tab-pane>
      <el-tab-pane :label="$t('ORG_GROUP')" name="Group">
        <ExamVault
          access-level="Group"
          :selectable="true"
          @selectExam="handleSelectExam"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ExamVault from './ExamVault.vue'

export default {
  name: 'ExamVaultView',
  components: {
    ExamVault
  },
  computed: {
    ...mapState('user', ['orgCategory']),
    userAccessLevel() {
      if (this.orgCategory === 'school') {
        return 'School'
      } else if (this.orgCategory === 'group') {
        return 'Group'
      } else {
        return 'Teacher'
      }
    }
  },
  data() {
    return {
      activeName: ''
    }
  },
  created() {
    this.activeName = this.userAccessLevel
  },
  methods: {
    handleClick(tab, event) {
      this.activeName = tab.name
    },
    handleSelectExam(questionGroups) {
      this.$emit('selectExam', questionGroups)
    }
  }
}
</script>
